import style from './Strategies.module.css';
import {StrategyEvent} from "../stores/events";
import NumberFormatter from "../libs/NumberFormatter";

export default function Stratiegies(props: {strategies: StrategyEvent[], cash: number, onStrategyBuy: (key: number) => void}) {

    return (
        <div className="px-4 py-2">
            <h2 className={`text-2xl ${style.mainTitle}`}>Dumberg Ads</h2>
            <div className="flex py-2">
                <div className="flex overflow-x-scroll no-scrollbar">
                    {
                        props.strategies.map((strategy, index) =>
                            <span
                                className="mr-6 flex-none w-36 max-w-36 h-64 max-h-64
                                border-b border-black border-dotted
                                leading-5"
                                key={index}
                            >
                                <div className="font-bold h-28 max-h-28">
                                    {strategy.title}
                                </div>
                                <div className="leading-5 text-sm">
                                    <span>Cost</span><span className="pl-1">{NumberFormatter.toCurrency(strategy.cost)}</span>
                                </div>
                                <div className="leading-5 text-sm">
                                    <span>Duration</span><span className="pl-1">{strategy.influence.endsIn} ticks</span>
                                </div>
                                <div className="leading-5 text-sm">
                                    <span>Influences in</span><span className="pl-1">{strategy.influence.startsIn} ticks</span>
                                </div>
                                <button
                                    className={`px-2 py-2 my-2 rounded border border-black 
                                    ${props.cash >= strategy.cost && !strategy.active ? "hover:bg-gray-200" : "bg-gray-400"}`}
                                    disabled={props.cash < strategy.cost || strategy.active}
                                    onClick={() => props.onStrategyBuy(index)}
                                >
                                    Buy
                                </button>
                            </span>
                        )
                    }
                </div>
            </div>
        </div>
    );

}